/**
 * Приём номеров: что решили с каждым присланным номером.
 *
 * Причина отказа сохраняется всегда, а не только факт «не взяли»:
 * по ней видно, сколько денег уходит на повторную закупку номеров,
 * по которым уже звонили.
 */
/** Решение по номеру при приёме (§5.3, тип intake_decision в базе) */
export const INTAKE_DECISIONS = [
    /** Принят, поставлен в очередь */
    'queued',
    /** Уже лежит в активной очереди */
    'dup_active',
    /** По номеру уже был лид */
    'dup_lead',
    /** Звонили недавно, окно повторной закупки не вышло */
    'dup_recent',
    /** Номер в списке отказов от обзвона */
    'blocked_dnc',
    /** Ранее был явный отказ */
    'blocked_negative',
    /** Не похоже на телефонный номер */
    'invalid_phone',
];
/** Принят ли номер в работу */
export function isAccepted(decision) {
    return decision === 'queued';
}
//# sourceMappingURL=source.js.map